import {CookieConsent, CookiesDto, CookiesDtoStage} from '../types';

const ENABLED_MARKETING = 1;
const ENABLED_STATISTICS = 2;

export function transformToDto(
  cookieConsent: CookieConsent | null
): CookiesDto | undefined {
  if (!cookieConsent) {
    return undefined;
  }

  return {
    list: getListBit(cookieConsent.categories),
    decided_at: cookieConsent.changedAt,
    stage:
      cookieConsent.acceptAt === cookieConsent.changedAt
        ? CookiesDtoStage.INIT
        : CookiesDtoStage.CHANGE,
  };
}

function getListBit(categories: CookieConsent['categories']) {
  let listBit = 0;

  if (categories.marketing) {
    listBit |= ENABLED_MARKETING;
  }

  if (categories.statistics) {
    listBit |= ENABLED_STATISTICS;
  }

  return listBit;
}
